/* PureAqua osmose-pagina's: galerij, keuzeveld en chatknop. */
(() => {
  document.querySelectorAll('[data-pao-gallery]').forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('[data-pao-thumb]');
    const slides = gallery.querySelectorAll('[data-pao-slide]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const view = thumb.dataset.paoThumb;
        slides.forEach((slide) => { slide.hidden = slide.dataset.paoSlide !== view; });
        thumbs.forEach((other) => {
          const on = other === thumb;
          other.classList.toggle('is-on', on);
          other.setAttribute('aria-pressed', String(on));
        });
      });
    });
  });

  const closeSelects = (except) => {
    document.querySelectorAll('details.lp-select[open]').forEach((d) => { if (d !== except) d.removeAttribute('open'); });
  };
  document.addEventListener('click', (event) => {
    const inside = event.target.closest('details.lp-select');
    closeSelects(inside);
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSelects(null); });

  // Meetpunten uit het meetplan: Clarity-events (alleen als Clarity al geladen is) en dataLayer voor GTM.
  const track = (name, data) => {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data));
      if (typeof window.clarity === 'function') window.clarity('event', name);
    } catch (e) { /* meten mag de pagina nooit breken */ }
  };
  document.addEventListener('click', (event) => {
    const design = event.target.closest('.lp-design a, a.lp-design');
    if (design) track('pao_design_click', { pao_target: design.getAttribute('href') });
    const buy = event.target.closest('[data-install-buy]');
    if (buy) {
      const choice = document.querySelector('[data-install-option]:checked');
      track('pao_add_to_cart_click', { pao_installation: choice ? choice.value : '' });
    }
    if (event.target.closest('[data-pao-chat]')) track('pao_chat_click', {});
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pao-chat]');
    if (!link) return;
    const widget = document.querySelector('respond-io-widget');
    const button = widget && widget.shadowRoot && widget.shadowRoot.querySelector('.speed-dial__button-root');
    if (button) {
      event.preventDefault();
      button.click();
    }
  });
})();
